import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Col, Collapse, Flex, Row } from 'antd'
import Button from '../../common/Button'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

const DtcsHeader = ({ dtcs, vehicleSid }) => {
  const intl = useIntl()
  const [activeKey, setActiveKey] = useState([])
  const dtcsSelected = dtcs.map((dtc) => dtc.name).join(', ')

  const togglePanel = (key) => {
    setActiveKey((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    )
  }

  const getDetails = () => {
    const length = dtcs?.length

    return (
      <ul className='dtc-list'>
        {dtcs.map((dtc) => (
            <li
              key={dtc.id}
              className={`dtc-list-item`}
            >
              <Row>
                <Col span={7} className="dtc-name">
                  {dtc.name}
                </Col>
                <Col span={7} className="dtc-acronym">
                  {dtc.acronym}
                </Col>
                <Col span={10} className="dtc-description">
                  {dtc.description}
                </Col>
              </Row>
            </li>
        ))}
      </ul>
    )
  }
  const items = [
    {
      key: '1',
      label: intl.formatMessage({ id: 'dtcs.listing.mappingCount' }, { count: dtcsSelected }),
      children: getDetails(),
      // showArrow: false,
      // collapsible: 'disabled',
      collapsible: 'icon',
      extra: (
        <Button
          type="link"
          className="link-button"
          onClick={(e) => {
            e.stopPropagation()
            togglePanel('1')
          }}
        >
          {activeKey.includes('1') ? intl.formatMessage({ id: 'dtcs.listing.closeDetails' }) : intl.formatMessage({ id: 'dtcs.listing.seeDetails' })}
        </Button>
      ),
    },
  ]

  return (
    <>
      <Collapse
        activeKey={activeKey}
        defaultActiveKey={['1']}
        items={items}
        size="small"
        className="dtc-header"
        expandIcon={({ isActive }) =>
          isActive ? (
            <MinusCircleOutlined className="collapse-icon" />
          ) : (
            <PlusCircleOutlined className="expand-icon" />
          )
        }
        expandIconPosition="end"
        onChange={(keys) => setActiveKey(keys)}
      />
    </>
  )
}

DtcsHeader.propTypes = {
  dtcs: PropTypes.array.isRequired,
  vehicleSid: PropTypes.string.isRequired,
}

export default DtcsHeader
